import { useEffect, useState } from 'react'
import { useAppDispatch } from '../../reducers/store'
import { fetchScansForDevice, selectActivity } from '../../reducers/activity'
import { useSelector } from 'react-redux'
import DataGrid from '../data-grid/DataGrid'
import checkIcon from '../../assets/check_circle.svg'
import { generateAndDownloadReport } from '../../reducers/alerts'
import PageSkeleton from '../skeleton/PageSkeleton'
import { Pagination } from '../pagination/Pagination'
import { Activity } from '../../types/ActivityTypes'
import { condensedActivityColumns } from '../activity/ActivityColumns'
import { DEFAULT_PAGE, MAXIMUM_PAGE_SIZE } from '../../strings/api-consts'
import { useParams } from 'react-router-dom'
import { selectUser } from '../../reducers/users'
import { PaginationSelectOption } from '../../types/MemberTypes'

interface IDeviceOverviewScansProps {
  setPopoutData: (data: { scanId: string; scanType: string }) => void
  setShowPopout: (show: boolean) => void
  demoDevice?: boolean
}

function DeviceOverviewScans(props: IDeviceOverviewScansProps) {
  const { setPopoutData, setShowPopout, demoDevice } = props
  const di = useAppDispatch()
  const { deviceId } = useParams()
  const { scans, totalPages, activityTableCurrentPage } = useSelector(selectActivity)
  const [dataLoading, setDataLoading] = useState<boolean>(true)
  const [scanToShow] = useState<string>('sysdiagnose')
  const { session } = useSelector(selectUser)

  useEffect(() => {
    setDataLoading(true)
    di(fetchScansForDevice(DEFAULT_PAGE, MAXIMUM_PAGE_SIZE, deviceId!, scanToShow))
  }, [])

  useEffect(() => {
    if (scans || (scans && (scans as Activity[]).length === 0)) {
      setDataLoading(false)
    } else if (!scans) {
      setDataLoading(true)
    }
  }, [scans])

  const handlePageClick = (data: PaginationSelectOption) => {
    setDataLoading(true)
    di(fetchScansForDevice(data.selected + 1, MAXIMUM_PAGE_SIZE, deviceId!, scanToShow))
  }

  const getScanDetails = async (scanId: string, scanType: string) => {
    const scanDetails = {
      scanId: scanId,
      scanType: scanType,
    }
    setPopoutData(scanDetails)
    setShowPopout(true)
  }

  const downloadAlertReport = async (scanId: string, isThreatHunter: boolean) => {
    const isDemoDownload = demoDevice || session?.user?.email === 'demo@acme-inc.io'
    await di(generateAndDownloadReport(scanId, isThreatHunter, isDemoDownload))
  }

  return (
    <>
      {(!scans || dataLoading) && (
        <div className="flex justify-center items-center min-h-screen">x
          <PageSkeleton />
        </div>
      )}
      {scans && scans.length > 0 && (
        <>
          <DataGrid
            columns={condensedActivityColumns(getScanDetails, downloadAlertReport)}
            data={scans}
            loading={dataLoading}
          />
          <div className="mt-2">
            <Pagination
              totalPages={totalPages}
              forcePage={activityTableCurrentPage}
              handlePageClick={handlePageClick}
            />
          </div>
        </>
      )}
      {scans && scans.length === 0 && (
        <div className="flex items-center justify-center h-screen">
          <div className="text-center -mt-32">
            <div className="flex items-center justify-center">
              <img src={checkIcon} alt="No open alerts found" className="h-12 w-12" />
            </div>
            <p className="font-bold">No Activity</p>
            <p className="text-sm">You have no activity to view</p>
          </div>
        </div>
      )}
    </>
  )
}

export default DeviceOverviewScans
